module.exports = __webpack_public_path__ + "img/avdeev.96de88eb.jpg";